import styled from 'styled-components';
import { PRIMARY } from '../../styles/colors';
import { INTER } from '../../styles/fonts';

export const Container = (styled.div<{ size?: number, $backgroundColor?: string }>`
  width: ${props => props.size || 48}px;
  height: ${props => props.size || 48}px;
  aspect-ratio: 1;
  border-radius: 50%;
  background-color: ${props => props.$backgroundColor || PRIMARY};
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-family: ${INTER.regular};
  font-size: ${props => (props.size ? props.size / 2.4 : 20)}px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
